/**
 * Section work component
 * 
 */

import React, { PureComponent } from 'react';

// Components

import Cards from '../cards/cards';

export default class SectionWork extends PureComponent {

	render() {
		
		const { data, items, template } = this.props;

		return (
			
			<div className="section">
				<div className="container">

					<Cards data={data} items={items} template={template} />

				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/sections/section-work.js